import { OffscreenRenderer } from "./OffscreenRenderer";
import { networkStatsService } from "./NetworkStatsService";
import { Vector2 } from "flavr-math";
import { MicState, PeerConnectionBrowserType } from "flavr-common";
import { coreUserService } from "../users";
const CLIENTS_RADIUS = 190;
const tmpVector2 = new Vector2();
const tmpVector2_1 = new Vector2();
export class OffscreenNetworkStatsRenderer extends OffscreenRenderer {
    constructor() {
        super(...arguments);
        this.lastDraw = 0;
    }
    draw(time) {
        if (networkStatsService.serverConnectionLost) {
            if (time - this.lastDraw >= 1000) {
                this.lastDraw = time;
                this.drawBackground();
                const centerX = this.width / 2;
                const centerY = this.height / 2;
                this.resetTransform();
                this.context.translate(centerX, centerY);
                this.context.font = `normal ${32}px Arial`;
                this.context.fillStyle = "White";
                this.context.textAlign = "center";
                this.context.textBaseline = "center";
                this.context.fillText("Connection to server lost", 0, 0);
                this.resetTransform();
                return true;
            }
            return false;
        }
        if (!networkStatsService.currentServerStats) {
            if (time - this.lastDraw >= 5000) {
                this.lastDraw = time;
                this.drawBackground();
                const centerX = this.width / 2;
                const centerY = this.height / 2;
                this.drawUser({
                    index: 0,
                    username: "Ich",
                    radius: 50,
                    pos: new Vector2(centerX, centerY),
                    rot: 0,
                    angle: 0,
                    microphoneAllowed: false,
                    microphoneSpeakerAllowed: false
                });
                return true;
            }
            return false;
        }
        if (!networkStatsService.process())
            return false;
        if (time - this.lastDraw < 200)
            return false;
        this.lastDraw = time;
        this.drawBackground();
        this.context.font = `normal ${12}px Arial`;
        const users = new Map();
        const centerX = this.width / 2;
        const centerY = this.height / 2;
        const thetaStart = /* Math.PI * 2 * 3 / 8 */ 0;
        const thetaLength = Math.PI * 2; /* - Math.PI * 2 * 2 / 8 */
        let segments = networkStatsService.currentServerStats.length;
        if (segments < 2) {
            segments += 1;
        }
        let index = 0;
        const connectionsMap = new Map();
        for (const client of networkStatsService.currentServerStats) {
            const segment = thetaStart + (index / segments) * thetaLength;
            const posX = CLIENTS_RADIUS * Math.cos(segment);
            const posY = CLIENTS_RADIUS * Math.sin(segment);
            for (const stats of client.connections) {
                const cHash = this.connectionHash(client.clientIdx, stats.clientIdx);
                let connection = connectionsMap.get(cHash);
                if (!connection) {
                    connection = {
                        from: client.clientIdx,
                        to: stats.clientIdx,
                        color: "green",
                        isUsingTurn: false,
                        micState: MicState.None,
                        clientConnections: []
                    };
                    connectionsMap.set(cHash, connection);
                }
                connection.clientConnections.push(stats);
            }
            users.set(client.clientIdx, {
                index,
                username: this.getUsername(client.clientIdx),
                radius: 50,
                pos: new Vector2(centerX + posX, centerY + posY),
                rot: 0,
                angle: segment,
                microphoneAllowed: client.microphoneAllowed,
                microphoneSpeakerAllowed: client.microphoneSpeakerAllowed,
                browserType: client.browserType
            });
            index++;
        }
        for (const connection of connectionsMap.values()) {
            this.processUserConnections(connection);
        }
        this.drawConnections(connectionsMap, users);
        for (const user of users.values()) {
            this.drawUser(user);
        }
        return true;
    }
    drawBackground() {
        this.resetTransform();
        this.context.clearRect(0, 0, this.width, this.height);
        this.context.fillStyle = "SteelBlue";
        this.context.fillRect(0, 0, this.width, this.height);
        this.context.strokeStyle = "white";
        this.context.lineWidth = 2;
        // ctx.lineJoin = 'bevel';
        // ctx.shadowColor = '#d53';
        // ctx.shadowBlur = 20;
        this.context.strokeRect(3, 3, this.width - 6, this.height - 6);
    }
    drawConnections(connections, users) {
        for (const connection of connections.values()) {
            const fromUser = users.get(connection.from);
            if (!fromUser)
                continue;
            const otherUser = users.get(connection.to);
            if (!otherUser)
                continue;
            this.resetTransform();
            tmpVector2.addVectors(fromUser.pos, otherUser.pos).multiplyScalar(0.5);
            tmpVector2_1.subVectors(otherUser.pos, fromUser.pos);
            tmpVector2_1.normalize();
            this.context.lineWidth = 4;
            this.context.strokeStyle = connection.color;
            this.context.beginPath();
            this.context.moveTo(fromUser.pos.x + tmpVector2_1.x * fromUser.radius, fromUser.pos.y + tmpVector2_1.y * fromUser.radius);
            this.context.lineTo(otherUser.pos.x - tmpVector2_1.x * otherUser.radius, otherUser.pos.y - tmpVector2_1.y * otherUser.radius);
            this.context.stroke();
            let infoText;
            if (connection.isUsingTurn) {
                if (infoText) {
                    infoText += " ";
                }
                else {
                    infoText = "";
                }
                infoText += "turn";
            }
            if (infoText) {
                const angle = tmpVector2_1.angle();
                this.resetTransform();
                this.context.fillStyle = "white";
                this.context.translate(tmpVector2.x, tmpVector2.y);
                this.context.rotate(angle + Math.PI);
                this.context.fillText(infoText, 0, 0);
                this.resetTransform();
            }
        }
    }
    drawUser(user) {
        this.resetTransform();
        this.context.lineWidth = 3;
        this.context.strokeStyle = "white";
        this.context.beginPath();
        this.context.arc(user.pos.x, user.pos.y, user.radius, 0, 2 * Math.PI);
        this.context.stroke();
        this.context.lineWidth = 8;
        this.context.translate(user.pos.x, user.pos.y);
        // this.context.rotate(user.angle + Math.PI / 2);
        this.context.font = `normal ${12}px Arial`;
        this.context.fillStyle = "white";
        this.context.textAlign = "center";
        this.context.textBaseline = "center";
        this.context.fillText(user.username, 0, 0);
        this.drawBrowserInfo(user);
        this.drawMicInfo(user);
    }
    drawBrowserInfo(user) {
        if (user.browserType === undefined)
            return;
        this.resetTransform();
        const browserName = this.getBrowserNameFromType(user.browserType);
        this.context.translate(user.pos.x, user.pos.y - 20);
        this.context.font = `normal ${8}px Arial`;
        this.context.fillStyle = "white";
        this.context.textAlign = "center";
        this.context.textBaseline = "center";
        this.context.fillText(browserName, 0, 0);
        this.resetTransform();
    }
    drawMicInfo(user) {
        if (!user.microphoneAllowed && !user.microphoneSpeakerAllowed)
            return;
        let micInfo;
        if (user.microphoneAllowed && user.microphoneSpeakerAllowed) {
            micInfo = "Mic und Audio";
        }
        else if (user.microphoneAllowed) {
            micInfo = "Mic";
        }
        else if (user.microphoneSpeakerAllowed) {
            micInfo = "Audio";
        }
        if (!micInfo)
            return;
        this.context.translate(user.pos.x, user.pos.y + 20);
        this.context.font = `normal ${8}px Arial`;
        this.context.fillStyle = "white";
        this.context.textAlign = "center";
        this.context.textBaseline = "center";
        this.context.fillText(micInfo, 0, 0);
        this.resetTransform();
    }
    processUserConnections(userConnection) {
        const mergedStats = {
            clientIdx: -1,
            connection: 0,
            iceGathering: 0,
            iceConnection: 0,
            signaling: 0,
            micState: MicState.MicAndAudio,
            isUsingTurn: false
        };
        const stats = userConnection.clientConnections;
        for (const stat of stats) {
            if (stat.connection > mergedStats.connection) {
                mergedStats.connection = stat.connection;
            }
            if (stat.iceGathering > mergedStats.iceGathering) {
                mergedStats.iceGathering = stat.iceGathering;
            }
            if (stat.iceConnection > mergedStats.iceConnection) {
                mergedStats.iceConnection = stat.iceConnection;
            }
            if (stat.signaling > mergedStats.signaling) {
                mergedStats.signaling = stat.signaling;
            }
            if (stat.micState === MicState.None) {
                mergedStats.micState = MicState.None;
            }
            else if (stat.micState === MicState.AudioOnly) {
                mergedStats.micState = MicState.AudioOnly;
            }
            else if (stat.micState === MicState.MicOnly) {
                mergedStats.micState = MicState.MicOnly;
            }
            if (stat.isUsingTurn) {
                mergedStats.isUsingTurn = stat.isUsingTurn;
            }
        }
        userConnection.color = this.processConnectionColor(mergedStats);
        userConnection.micState = mergedStats.micState;
        userConnection.isUsingTurn = mergedStats.isUsingTurn;
    }
    processConnectionColor(stats) {
        if (stats.connection >= 3) {
            return "Red";
        }
        if (stats.connection >= 2) {
            return "Khaki";
        }
        if (stats.connection >= 1) {
            return "GreenYellow";
        }
        if (stats.iceConnection >= 4) {
            return "Red";
        }
        if (stats.iceConnection >= 2) {
            return "LightCoral";
        }
        if (stats.iceConnection >= 1) {
            return "GreenYellow";
        }
        if (stats.signaling >= 1) {
            return "Khaki";
        }
        if (stats.iceConnection >= 2) {
            return "Khaki";
        }
        if (stats.iceConnection >= 1) {
            return "GreenYellow";
        }
        return "green";
    }
    connectionHash(clientIdxA, clientIdxB) {
        if (clientIdxA < clientIdxB) {
            return `${clientIdxA}_${clientIdxB}`;
        }
        return `${clientIdxB}_${clientIdxA}`;
    }
    getUsername(clientIdx) {
        const userInfo = coreUserService.getUserByClientIdx(clientIdx);
        if (!userInfo)
            return `${clientIdx}`;
        if (coreUserService.isLocalUser(userInfo))
            return "Ich";
        return coreUserService.getDisplayNameByUser(userInfo);
    }
    getBrowserNameFromType(type) {
        switch (type) {
            case PeerConnectionBrowserType.Chrome:
                return "Chrome";
            case PeerConnectionBrowserType.Chromium:
                return "Chromium";
            case PeerConnectionBrowserType.Edge:
                return "Edge";
            case PeerConnectionBrowserType.Firefox:
                return "Firefox";
            case PeerConnectionBrowserType.FirefoxReality:
                return "FirefoxReality";
            case PeerConnectionBrowserType.Focus:
                return "Focus";
            case PeerConnectionBrowserType.InternetExplorer:
                return "IE";
            case PeerConnectionBrowserType.OculusBrowser:
                return "OculusBrowser";
            case PeerConnectionBrowserType.Opera:
                return "Opera";
            case PeerConnectionBrowserType.Safari:
                return "Safari";
            case PeerConnectionBrowserType.SamsungInternet:
                return "Samsung";
            default:
                return "Other";
        }
    }
}
